

// const styles =
export default require('./IconCss.module.scss');

// ?not work
// export default styles;
